import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';

@Component({
  selector: 'app-connection-icon',
  templateUrl: './connection-icon.component.html',
  styleUrls: ['./connection-icon.component.css']
})
export class ConnectionIconComponent implements ICellRendererAngularComp {
  params: ICellRendererParams;
  agRowData: any;
  isConnect: boolean = false;
  // @Input() isConnected: boolean = false;
  @Input() set isConnected(status: boolean) {
    console.log('status: ', status);
    this.isConnect = status || false;
  }

  get status() {
    return this.params?.data?.isConnected || this.isConnect;
  }

  agInit(params: ICellRendererParams): void {
    console.log('isConnected: ', this.isConnected);
    console.log('this.params?.data?: ', this.params);
    this.params = params;
    this.agRowData = params.node.data;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

}
